import Ajv from 'ajv';
import addFormats from 'ajv-formats';

import * as data_schema from './src/eidos/data.json';
import * as oceanql_schema from './src/datamesh/oceanql.json';
import * as plot_schema from './src/eidos/node/plot.json';
import * as world_schema from './src/eidos/node/world.json';
import * as vega_schema from './src/vega.json';
import * as document_schema from './src/eidos/node/document.json';
import * as grid_schema from './src/eidos/node/grid.json';
import * as menu_schema from './src/eidos/node/menu.json';
import * as derived_schema from './src/eidos/node/derived.json';
import * as eidos_schema from './src/eidos/root.json';
import * as common_schema from './src/eidos/common.json';
import * as panel_schema from './src/eidos/panel.json';
import * as theme_schema from './src/eidos/theme.json';
import * as geojson_schema from './src/geojson.json';
import * as track_schema from './src/eidos/node/worldlayer/track.json';
import * as feature_schema from './src/eidos/node/worldlayer/feature.json';
import * as gridded_schema from './src/eidos/node/worldlayer/gridded.json';
import * as label_schema from './src/eidos/node/worldlayer/label.json';
import * as scenegraph_schema from './src/eidos/node/worldlayer/scenegraph.json';
import * as seasurface_schema from './src/eidos/node/worldlayer/seasurface.json';
import * as wmts_schema from './src/eidos/node/worldlayer/wmts.json';
import * as layer_schema from './src/eidos/node/worldlayer/common.json';

const schemaValidator = addFormats(
  new Ajv({
    //useDefaults: true,
    //coerceTypes: true,
    schemas: [
      eidos_schema,
      data_schema,
      oceanql_schema,
      plot_schema,
      world_schema,
      document_schema,
      vega_schema,
      common_schema,
      panel_schema,
      grid_schema,
      menu_schema,
      derived_schema,
      theme_schema,
      geojson_schema,
      track_schema,
      feature_schema,
      gridded_schema,
      label_schema,
      scenegraph_schema,
      seasurface_schema,
      wmts_schema,
      layer_schema,
    ],
    strict: false,
  }),
);

schemaValidator.addKeyword('dataType', {
  validate: function (schema, data) {
    switch (schema) {
      case 'bigint':
        return typeof data === 'bigint';

      default:
        return schemaValidator.compile({ type: schema })(data);
    }
  },
  errors: true,
});

export {
  eidos_schema,
  data_schema,
  oceanql_schema,
  plot_schema,
  world_schema,
  document_schema,
  vega_schema,
  common_schema,
  panel_schema,
  grid_schema,
  menu_schema,
  derived_schema,
  theme_schema,
  geojson_schema,
  // Worldlayer subtypes — exposed so the framework's derive-schema
  // registry can build a complete `allSchemas` map for cross-ref
  // walking inside cloned subtrees.
  track_schema,
  feature_schema,
  gridded_schema,
  label_schema,
  scenegraph_schema,
  seasurface_schema,
  wmts_schema,
  layer_schema,
  schemaValidator,
};
